// directusClient.js
import { createDirectus, authentication, rest } from "@directus/sdk";

const client = createDirectus("https://zedlenders.pickmesms.com/")
  .with(rest())
  .with(authentication());

export default client;
